function s(i) {
  return function(e, l, f) {
    for (var u = -1, r = Object(e), a = f(e), n = a.length; n--; ) {
      var t = a[i ? n : ++u];
      if (l(r[t], t, r) === !1)
        break;
    }
    return e;
  };
}
export {
  s as default
};
